import img1 from '../Images/AmericanLife/1.png';
import img2 from '../Images/AmericanLife/2.png';
import img4 from '../Images/AmericanLife/4.png';
import img5 from '../Images/AmericanLife/5.png';
import img6 from '../Images/AmericanLife/6.png';
import img7 from '../Images/AmericanLife/7.png';
import img8 from '../Images/AmericanLife/8.png';
import img9 from '../Images/AmericanLife/9.png';
import img10 from '../Images/AmericanLife/10.png';
import img11 from '../Images/AmericanLife/11.png';
import img12 from '../Images/AmericanLife/12.png';
import img13 from '../Images/AmericanLife/13.png';
import img14 from '../Images/AmericanLife/14.png';
import img15 from '../Images/AmericanLife/15.png';
import img16 from '../Images/AmericanLife/16.png';
import img17 from '../Images/AmericanLife/17.png';
// New videos
import img22 from '../Images/AmericanLife/22-min.png';
import img23 from '../Images/AmericanLife/23-min.png';
import img24 from '../Images/AmericanLife/24-min.png';
import img25 from '../Images/AmericanLife/25-min.png';
import img26 from '../Images/AmericanLife/26-min.png';
import img27 from '../Images/AmericanLife/27-min.png';
import img28 from '../Images/AmericanLife/28-min.png';
import img29 from '../Images/AmericanLife/29-min.png';
import img30 from '../Images/AmericanLife/30-min.png';
import img31 from '../Images/AmericanLife/31-min.png';
import img32 from '../Images/AmericanLife/32-min.png';
import img33 from '../Images/AmericanLife/33-min.png';
import img34 from '../Images/AmericanLife/34-min.png';
import img35 from '../Images/AmericanLife/35-min.png';
import img36 from '../Images/AmericanLife/36-min.png';
import img37 from '../Images/AmericanLife/37-min.png';
import img38 from '../Images/AmericanLife/38-min.png';
import img39 from '../Images/AmericanLife/39-min.png';
import img40 from '../Images/AmericanLife/40-min.png';

export const getVideosAmericanLife = () => {
  const data = [
        {
      title:
        '5 Practical Ways to Improve Effective Communication Skills Every Day',
      image: img22,
      url: 'cPajChiAZPU',
      duration: '4:38',
      description: `Learn these 5 ways to improve effective communication skills.`,
      language: 'EN',
      type: 'youtube',
    },
    {
      title:
        '5 Proper Workplace Etiquette Tips to Practice for Professional Success',
      image: img23,
      url: 'etxASaYtJu8',
      duration: '1:18',
      description: `When starting a new job, you want to be on top of your game. Keep in mind
these office etiquette tips to make sure you're staying professional, courteous.`,
      language: 'EN',
      type: 'youtube',
    },
    {
      title: '5 Tips For Effective Teamwork',
      image: img24,
      url: 'n_UhsBZNADM',
      duration: '1:36',
      description: `Effective teamwork is the key to a successful business, as it increases
productivity levels and produces better solutions to problems. Companies
that foster.`,
      language: 'EN',
      type: 'youtube',
    },
    {
      title: 'Cambia tu mente, cambia tu vida | Margarita Pasos | TEDxManagua',
      image: img25,
      url: 'uhZzB5hid6M',
      duration: '20:43',
      description: `Margarita nos habla sobre la importancia de controlar nuestro dialogo
interior y como esto puede llevarnos al éxito o al fracaso. Conferencista
internacional.`,
      language: 'ES',
      type: 'youtube',
    },
    {
      title:
        'Dime cómo hablas y te diré quién eres | Jousin Palafox | TEDxTijuana',
      image: img26,
      url: '3X30vGbLol8',
      duration: '13:06',
      description: `Nos encontramos hablando ante un público constantemente: Cuando nos
postulamos a un trabajo o cuando queremos vender algo, por mencionar
algunos ejemplos.`,
      language: 'ES',
      type: 'youtube',
    },
    {
      title:
        'How emotional intelligence can improve your workplace | Kul Mahay | TEDxWolverhampton',
      image: img27,
      url: 'kJcLzoh46O0',
      duration: '16:14',
      description: `In his talk, ‘Why Emotional Intelligence is the New Superpower’ Kul
explores the changed world of work in a post covid environment that has
seen our focus`,
      language: 'EN',
      type: 'youtube',
    },
    {
      title:
        'How to be confident (even if you’re not) | Montana von Fliss | TEDxBellevueWomen',
      image: img28,
      url: 'eVFzbxmKNUw',
      duration: '16:07',
      description: `The number one question Montana von Fliss is asked is how to be more
confident. Over her 16 years of coaching speakers all over the globe and 30
years as a...`,
      language: 'EN',
      type: 'youtube',
    },
    {
      title: 'Professionalism',
      image: img29,
      url: 'qD0je-DNg40',
      duration: '16:07',
      description: `Professionalism is essential to employers because it assures them you'll react
appropriately and make sound decisions when facing challenges.
Understanding...`,
      language: 'EN',
      type: 'youtube',
    },
    {
      title: 'Professionalism: The Key to Success in the Workplace',
      image: img30,
      url: 'IWqI5JLJ7_g',
      duration: '4:02',
      description: `In this video, we delve into the crucial topic of professionalism in the
workplace and how it can pave the way for unprecedented success in your
career.`,
      language: 'EN',
      type: 'youtube',
    },
    {
      title:
        'The Science Behind Dramatically Better Conversations | Charles Duhigg | TED',
      image: img31,
      url: 'K_RSZC0s8a4',
      duration: '4:02',
      description: `The key to deeply connecting with others is about more than just talking —
it's about asking the right kinds of questions, says journalist and author
Charles...`,
      language: 'EN',
      type: 'youtube',
    },
    {
      title:
        'The Secret to Finding Your Ideal Workplace | Marion Campan | TED',
      image: img32,
      url: 's9rCzZEZKnM',
      duration: '14:51',
      description: `What's the most important thing to look for when applying for a new job?
Entrepreneur Marion Campan advocates for a focus on company culture
above all else. She offers practical strategies for evaluating companies before
accepting a new position — including how to ask the right questions about
values, feedback and expectations — to help job seekers find positions where
they can thrive.`,
      language: 'EN',
      type: 'youtube',
    },
    {
      title:
        'Time Management Techniques For Stress Free Productivity',
      image: img33,
      url: 'IGVQPU-L7cQ',
      duration: '4:21',
      description: `Introducing! A Better way to Understand Time Management Techniques,
That helps for stress free Productivity.`,
      language: 'EN',
      type: 'youtube',
    },
    {
      title:
        'What Are The Keys to Effective Teamwork',
      image: img34,
      url: '32-V3_KDl9A',
      duration: '5:01',
      description: `El trabajo en equipo eficaz requiere más que la simple participación grupal: exige una comunicación sólida, coordinación y apoyo mutuo. Según el modelo de calidad del trabajo en equipo de Hoegl, seis elementos clave definen el éxito de un equipo: comunicación, coordinación, contribuciones equilibradas, apoyo mutuo, esfuerzo compartido y cohesión.`,
      language: 'ES',
      type: 'youtube',
    },
    {
      title:
        'What to Wear For a Technician or Mechanic Job Interview',
      image: img35,
      url: 'AzbkEQ0OzKY',
      duration: '2:33',
      description: `A question we get fairly often is asking what a technician should wear to a job interview.`,
      language: 'EN',
      type: 'youtube',
    },
    {
      title:
        'W#TheBetterWay (e21) Professional Appearance',
      image: img36,
      url: '2qtjhwJ0LAE',
      duration: '3:00',
      description: `Appearance is part of your first impression.  I'm not talking about your physical appearance, but rather your PROFESSIONAL APPEARANCE! Think of any great leader or influencer in recent years and you will see they have a consistent PROFESSIONAL APPEARANCE.`,
      language: 'EN',
      type: 'youtube',
    },
    {
      title:
        'Punctuality:The Secret 15 Habits of Highly Successful People | Graded Reader | Improve Your English',
      image: img37,
      url: 'zQ_ez3INRZg',
      duration: '23:35',
      description: `Do you always feel like you're running out of time? Want to become more organized, confident, and successful in life?`,
      language: 'EN',
      type: 'youtube',
    },
    {
      title:
        'Professionalism in the workplace',
      image: img38,
      url: 'fK2BNXcP_7o',
      duration: '13:24',
      description: `Professionalism in the workplace`,
      language: 'EN',
      type: 'youtube',
    },
    {
      title:
        'Tips on the Power of Being Punctual [You Are in Control, Discipline, and it Can Be Cultivated]',
      image: img39,
      url: 'mSX32-pFcao',
      duration: '7:12',
      description: `To shift the viewer's perception of time and punctuality: To move from a feeling of being controlled by time to a sense of agency and control.`,
      language: 'EN',
      type: 'youtube',
    },
    {
      title:
        'Minilección sobre ética laboral | Comportamiento ético e integridad en el trabajo',
      image: img40,
      url: 'v5HGe6-ADXQ',
      duration: '4:32',
      description: `Bienvenido a la capacitación en ética laboral para empleados de Business Training Media | Minilección. En solo unos minutos, aprenderá cómo el comportamiento ético moldea la confianza, el trabajo en equipo y el profesionalismo en el lugar de trabajo.`,
      language: 'ES',
      type: 'youtube',
    },
    {
      title:
        'How to Speak With Confidence: Crash Course Business - Soft Skills',
      image: img1,
      url: 'sjdxUiAJ0UQ',
      duration: '11:11',
      description:
        'Public speaking is not easy for everyone. It can be nerve racking and even scary. But, in this episode of Crash Course Business Soft Skills, Evelyn talks to us about S.U.C.C.E.S and how we can use it to help us be prepared to speak to a group.',
      language: 'EN',
      type: 'youtube',
    },
    {
      title:
        'How to Speak With Confidence: Crash Course Business - Soft Skills',
      image: img2,
      url: '2Si7ah_h32s',
      duration: '10:59',
      description:
        'Most of us struggle with time management. It is normal. But, things need to get done both at work and in your personal life. So, in this episode of Crash Course Business, Evelyn gives us all some ways to structure our checklist and make sure we get our work done while still not forgetting to take care of ourselves.',
      language: 'EN',
      type: 'youtube',
    },
    {
      title:
        'How to Avoid Teamwork Disasters: Crash Course Business - Soft Skills',
      image: img4,
      url: 'fRj7Am63wVc',
      duration: '14:19',
      description: `Group projects have a reputation of being difficult at times. But there are ways to make sure everything from the project to meetings about the project go smoothly. In this episode, Evelyn chats about how we can make sure and avoid dreaded teamwork disasters.`,
      language: 'EN',
      type: 'youtube',
    },
    {
      title: 'What Are Communication Skills? Top 10!',
      image: img5,
      url: 'xQfYiHbAjJo',
      duration: '7:21',
      description: `What are Communication Skills? We'll look at the Top 10 Communication Skills according to employers' surveys. These are the ones they want you to know and my class in the 5 Essential Professional`,
      language: 'EN',
      type: 'youtube',
    },
    {
      title: 'Public speaking for beginners',
      image: img6,
      url: 'i5mYphUoOCs',
      duration: '5:51',
      description: `The video looks at being organized and concise, making direct eye contact, using fewer notes to speak more extemporaneous, using simple slides for visual aids, and a confident posture, gestures, and voice.`,
      language: 'EN',
      type: 'youtube',
    },
    {
      title: 'Problem Solving: 6 Skills needed to solve any problem',
      image: img7,
      url: 'klAE9ML0XLs',
      duration: '2:19',
      description: `In our world today, every business or individual faces problems sometimes on a daily basis. Since removing obstacles is essential along your business’s path to success, this video shows you 6 skills suggested to help you become an excellent problem solver.`,
      language: 'EN',
      type: 'youtube',
    },
    {
      title: '5 Common Ethical Issues in the Workplace | Leadership Coaching',
      image: img8,
      url: 'OnD_prSrm3Q',
      duration: '6:47',
      description: `In this video, Shelley Benhoff talks about 5 Common Ethical Issues in the Workplace and Leadership Coaching.`,
      language: 'EN',
      type: 'youtube',
    },
    {
      title: '15 Strategies to Improve Your Problem Solving Skills',
      image: img9,
      url: 'kRtdcBfvixE',
      duration: '14:16',
      description: `Alux.com is the largest community of luxury & fine living enthusiasts in the world. We are the #1 online resource for ranking the most expensive things in the world and frequently referenced in publications such as Forbes, USAToday, Wikipedia and many more, as the GO-TO destination for luxury content!`,
      language: 'EN',
      type: 'youtube',
    },
    {
      title: 'How to Ace the Interview: Crash Course Business - Soft Skills',
      image: img10,
      url: 'BssdOyLB2GU',
      duration: '11:30',
      description: `If you’ve got a job interview coming up and you’re feeling a little nervous, don’t worry. If you’re anything like me, you’ve probably seen enough celebrity interviews to know what works and what doesn’t. Sure, it's not as flashy, but you know what we mean! In this episode, Evelyn sits down to chat about how you can ace your next interview.`,
      language: 'EN',
      type: 'youtube',
    },
    {
      title:
        'How to Write a Resume Summary - Plus 5 Strong Examples | Indeed Career Tips',
      image: img11,
      url: 'HjNk6MVpWsM',
      duration: '8:47',
      description: `How can you capture a recruiter's attention immediately when they may spend less than 7 seconds reviewing the document? The answer is a resume summary - short paragraph which should tell a brief, compelling story about who you are as a professional. In this video, Jenn, a certified Career Coach, shares 6 key steps to create a resume summary that best communicates your strengths to recruiters.`,
      language: 'EN',
      type: 'youtube',
    },
    {
      title: 'Adaptability in the workplace',
      image: img12,
      url: 'rlmX1yWt_SI',
      duration: '1:56',
      description:
        'Adaptability is one of the keys to managing your emotions in the workplace. This short video looks at why it is important, and gives you some tips to help increase your adaptability.',
      language: 'EN',
      type: 'youtube',
    },
    {
      title: 'Adaptability & Flexibility - SkillsUSA',
      image: img13,
      url: '2A1TN9_8Kr0',
      duration: '2:07',
      description:
        'For more information and learning resources please visit: kevinjfleming.com and skillsusa.org',
      language: 'EN',
      type: 'youtube',
    },
    {
      title: 'What are Resilience and Adaptability Skills',
      image: img14,
      url: 'lDPCPmBY4Pw',
      duration: '3:01',
      description:
        'This video introduces the concepts of resilience and adaptability, in preparation for the PSA Online Course: Developing Resilience and Adaptability.',
      language: 'EN',
      type: 'youtube',
    },
    {
      title:
        'How to Improve Critical Thinking Skills in The Workplace - Executive Coaching',
      image: img15,
      url: 'qtreTIcqERY',
      duration: '14:19',
      description: `Do you want to improve your critical thinking skills in the workplace? Learn and develop this disciplined process through Dr. Grace Lee's executive coaching program`,
      language: 'EN',
      type: 'youtube',
    },
    {
      title: '5 Types of Conflict in the Workplace and How To Handle Them',
      image: img16,
      url: 'o7-bbd1F9bk',
      duration: '14:46',
      description: `Here are the five most common types of conflict in the workplace. Along with two tips for dealing with the most common (and complex)... personality conflicts at work`,
      language: 'EN',
      type: 'youtube',
    },
    {
      title: 'Developing Critical Thinking Skills',
      image: img17,
      url: 'Iwnwq3buLjI',
      duration: '2:17',
      description: `Developing Critical Thinking Skills.`,
      language: 'EN',
      type: 'youtube',
    },
  ];

  return data;
};
